var map = {
	"./en.js": 1278,
	"./es.js": 1279,
	"./index.js": 680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1277;


//////////////////
// WEBPACK FOOTER
// ./src/helper/ln nonrecursive \.js$
// module id = 1277
// module chunks = 33